import * as paramTypes from '@/types/accessor/api/s3/s3'
import { callApi } from './requests/disasterCommonS3ApiGwFuncs'

/**
 * ファイルのキー一覧を取得する
 * @param params S3APiの'listObjects'関数のリクエストパラメータ
 * @returns キーの一覧 or エラー
 */
export const fetchKeys = async (
  params: paramTypes.ReqFetchKeys
): Promise<paramTypes.FetchKeysResponse> => {
  const request: paramTypes.Request<paramTypes.ReqFetchKeys> = {
    function: 'listObjects',
    params: params
  }
  return await callApi<paramTypes.ReqFetchKeys, paramTypes.ResFetchKeys>(request)
}

/**
 * 証明書付きURLを取得する
 * @param params S3APIの'getPresignedUrl'関数のリクエストパラメータ
 * @returns 証明書付きURLの一覧 or エラー
 */
export const fetchPresignedUrl = async (
  params: paramTypes.ReqFetchPresignedUrl
): Promise<paramTypes.FetchPresignedUrlResponse> => {
  const request: paramTypes.Request<paramTypes.ReqFetchPresignedUrl> = {
    function: 'getPresignedUrl',
    params: params
  }
  return await callApi<paramTypes.ReqFetchPresignedUrl, paramTypes.ResFetchPresignedUrl>(request)
}

/**
 * S3上のファイルを削除する
 * @param params S3APIの'delete'関数のリクエストパラメータ
 * @returns 削除したファイルのキーの一覧 or エラー
 */
export const deleteFiles = async (
  params: paramTypes.ReqDeleteFiles
): Promise<paramTypes.DeleteFilesResponse> => {
  const request: paramTypes.Request<paramTypes.ReqDeleteFiles> = {
    function: 'delete',
    params: params
  }
  return await callApi<paramTypes.ReqDeleteFiles, paramTypes.ResDeleteFiles>(request)
}
